












































































































import { Component, Prop, Mixins } from "vue-property-decorator";

// Mixins
import { FilteringSortingTableStore } from "@/mixins/tableWithFilteringAndSortingStore";
import TermsAndConditionsInjectorMixin from "@/mixins/termsAndConditionsInjectorMixin";

// Enums/Data
import { DataModules } from "@/store/modules/data";

// Types
import { IFilter, ISorter } from "@/models/tables";
import { FilterTypes, FilterOperators } from "@/data/table";
import { IBrand } from "@/models/brands";
import { ITermsAndConditions } from "@/models/termsAndConditions";

@Component
export default class TermsAndConditionsTable extends Mixins(
  FilteringSortingTableStore,
  TermsAndConditionsInjectorMixin
) {
  @Prop({ required: true })
  public brandId!: IBrand["id"];

  @Prop({ default: "" })
  public currentId!: string;

  public loading = true;
  public isProcessing = false;

  public filters: IFilter[] = [
    {
      key: "created_at",
      label: this.$t("_.created"),
      type: FilterTypes.DATE,
      operator: FilterOperators.EQUAL
    }
  ];

  public sorters: ISorter[] = [
    {
      field: "created_at",
      label: this.$t("_.created")
    }
  ];

  public dataModule = DataModules.TERMS_AND_CONDITIONS;

  public created() {
    this.apiProps = {
      brand_id: this.brandId,
      with: "terms"
    };
    this.getData();
  }

  public viewTerms(termsId) {
    this.$store.dispatch(
      `data/${DataModules.TERMS_AND_CONDITIONS}/openPreviewModal`,
      {
        props: {
          termsId,
          useTranslated: false
        }
      }
    );
  }

  public async revert(termsAndConditions: ITermsAndConditions) {
    if (!this.canCreate) return;

    const confirm = await this.$store.dispatch("ui/open/confirmModal", {
      config: {
        props: {
          autoClose: false,
          confirmButtonText: this.$t("_action.revert"),
          message: this.$t("_sentence.terms.confirm_revert")
        },
        events: {
          confirmed: async () => {
            try {
              this.isProcessing = true;
              await this.revertTermsAndConditions(termsAndConditions);
              await this.$termsAndConditionsMethods.reloadData();
              await this.getData({ ignoreStored: true });
              this.$store.dispatch("toast/show", {
                message: this.$t("_sentence.terms.successfully_reverted")
              });
            } catch (error) {
              this.$store.dispatch("api/handleError", error);
            } finally {
              this.isProcessing = false;
            }
            confirm.close();
          }
        }
      }
    });
  }

  public revertTermsAndConditions(termsAndConditions: ITermsAndConditions) {
    return this.$store.dispatch(
      `data/${DataModules.TERMS_AND_CONDITIONS}/create`,
      {
        data: termsAndConditions.terms
      }
    );
  }

  // Computed

  public get canCreate() {
    return this.$userCan("create_terms_and_conditions");
  }
}
